export default __webpack_public_path__ + "a507f68c85fb46a90e46f8f8bd18c0dd.png";